import React from 'react'

interface RadioProps {
  selected: boolean
}

const CheckedRadio = (
  <div className="h-[13px] w-[13px] rounded-full flex border-black border-1 justify-center items-center p-[2px]">
    <div className="h-[7px] w-[7px] rounded-full bg-black" />
  </div>
)

const UncheckedRadio = (
  <div className="h-[13px] w-[13px] rounded-full border-verylight-gray border-1" />
)

const Radio = ({ selected }: { selected: boolean }) => selected
  ? CheckedRadio
  : UncheckedRadio

export default Radio